import React, { useState, useEffect, useContext, useRef } from 'react';

import styles from 'components/layout_and_quote_builder/_style.module.scss';
import LayoutNavSectionCombination from 'components/layout_and_quote_builder/LayoutNavSectionCombination.jsx';

const LayoutNavSectionCombinationListList = ({ list, count, setSelectedList, machineNotFoundFiltering }) => {
  const [totalScore, setTotalScore] = useState(0)
  const [totalScoreList, setTotalScoreList] = useState({})
  const [numTotals, setNumTotals] = useState( {} )
  const [numOfDrawingsInSet, setNumOfDrawingsInSet] = useState( {} )
  const [machineFoundStatus, setMachineFoundStatus] = useState( {} )

  const handleClick = () => {
    setSelectedList( list )
  }

  const showNavSectionCombination = ( result, index ) => {
    return <LayoutNavSectionCombination
      index = {index}
      diecutting_result={result.diecutting_result}
      count={count}
      layout_dimension={result.material_layout_dimension}
      setTotalScoreList={setTotalScoreList}
      setNumTotals={setNumTotals}
      setNumOfDrawingsInSet={setNumOfDrawingsInSet}
      setMachineFoundStatus={setMachineFoundStatus}
      machineNotFoundFiltering={machineNotFoundFiltering}
    />
  }

  // Check if all children have reported their status and all have machines not found
  const allStatusesReported = Object.keys(machineFoundStatus).length === list.length;
  const allMachinesNotFound = allStatusesReported && Object.values(machineFoundStatus).every(status => status === false);

  useEffect( () => {
    for(let i = 0; i < list.length; i++ ) {
      list[i].num_total_diecutting = numTotals[i]
      list[i].num_total_printing   = numTotals[i] * list[i].diecutting_result.printing_result.num_x  * list[i].diecutting_result.printing_result.num_y
    }
  }, [numTotals] )


  useEffect( () => {
    setTotalScore( () => Object.values(totalScoreList).reduce((a, b) => a + b, 0)  )
  }, [totalScoreList])

  useEffect( () => {
    for(let i = 0; i < list.length; i++ ) {
      list[i].num_of_drawings_in_set = numOfDrawingsInSet[i]
    }
  }, [numOfDrawingsInSet] )

  // Hide entire container if all machines were not found (only when filtering is enabled)
  if (machineNotFoundFiltering && allMachinesNotFound) {
    return null;
  }

  return (
    <div className={styles.combinations_grid_item_cont} key={name} data-score={totalScore} onClick={handleClick}>
      <div style={{fontSize: '12px' }} className="stars-rating-container"></div>

      {list.map((result, index) => (
        <React.Fragment key={index}>
          {showNavSectionCombination(result, index)}
        </React.Fragment>
      ))}
    </div>
  )
}

export default LayoutNavSectionCombinationListList;
